import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {LeaderboardsService} from './services/leaderboards.service';

@NgModule({
  imports: [CommonModule], providers: [LeaderboardsService]
})
export class CoachBotDataAccessLeaderboardsModule {}
